import { ChevronRightIcon } from '@chakra-ui/icons';
import { IconButton } from '@chakra-ui/react';
import cx from 'classnames';
import React from 'react';

import Link from '../../../../Link';
import { H3, Text } from '../../../../Text';
import { Feature } from '../../../types';
import * as Styles from './Template.module.scss';

interface FeatureBoxProps {
  feature: Feature | null | undefined;
}

const FeatureBox: React.FC<FeatureBoxProps> = ({ feature }) => {
  if (!feature) {
    return null;
  }
  return (
    <Link
      className={cx(Styles.MegaMenu__Link, Styles.MegaMenu__LinkIsFeatureLink)}
      to={feature.url}
      variant="plain"
    >
      <H3 className={Styles.MegaMenu__Link__Header}>{feature.item}</H3>
      <Text className={Styles.MegaMenu__Link__Description}>
        {feature.description}
      </Text>
      <IconButton
        aria-label="Get more information"
        icon={<ChevronRightIcon />}
        variant="outline"
        colorScheme="blue"
      />
    </Link>
  );
};

export default FeatureBox;
